export const FeaturedProjectPlaceholder = () => {
  return <div className="h-[560px] w-full animate-pulse sm:h-[640px] lg:h-[720px] 2xl:h-[900px] 3xl:h-[1200px]" />
}
